import React, { createContext, useContext, useState } from "react";
import CreateDiscoveryRequestTaskResponseDialog from "../components/Dialogs/CreateDiscoveryRequestTaskResponseDialog/CreateDiscoveryRequestTaskResponseDialog";
import { DiscoveryRequestTask } from "../models/DiscoveryRequestTask";

interface Context {
  openDialog: (discoveryRequestTask: DiscoveryRequestTask) => void;
  closeDialog: () => void;
  isOpen: boolean;
  discoveryRequestTask: DiscoveryRequestTask | undefined;
}

const CreateDiscoveryRequestTaskResponseDialogContext = createContext<
  Context | undefined
>(undefined);

export const CreateDiscoveryRequestTaskResponseDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [discoveryRequestTask, setDiscoveryRequestTask] = useState<
    DiscoveryRequestTask | undefined
  >(undefined);
  const [isOpen, setIsOpen] = useState(false);

  const openDialog = (discoveryRequestTask: DiscoveryRequestTask) => {
    setDiscoveryRequestTask(discoveryRequestTask);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setDiscoveryRequestTask(undefined);
  };

  return (
    <CreateDiscoveryRequestTaskResponseDialogContext.Provider
      value={{ openDialog, closeDialog, isOpen, discoveryRequestTask }}
    >
      {discoveryRequestTask && (
        <CreateDiscoveryRequestTaskResponseDialog
          isOpen={isOpen}
          discoveryRequestTask={discoveryRequestTask}
          setIsOpen={setIsOpen}
        />
      )}
      {children}
    </CreateDiscoveryRequestTaskResponseDialogContext.Provider>
  );
};

export const useCreateDiscoveryRequestTaskResponseDialog = () => {
  const ctx = useContext(CreateDiscoveryRequestTaskResponseDialogContext);
  if (!ctx)
    throw new Error(
      "useCreateDiscoveryRequestTaskResponseDialog must be used inside CreateDiscoveryRequestTaskResponseDialogProvider",
    );
  return ctx;
};
